import { Box, Button, Divider, Grid } from '@mui/material';
import React from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import WSTextField from '../TextBox/WSTextBox';
import { IsSmallScreen } from '../../commonFunctions/CommonFunctions';

interface IFilterSearchTextProps {
    rows: IRows;
    onFilterChange: (filters: IFilter[]) => void;
    alignment?: 'left' | 'center' | 'right';
    defaultFilter?:any[]
}

export interface IRows {
    fieldName?: string;
}

interface IFilter {
    field: string;
    operator: Operator | string;
    value: string | number;
}

export enum Operator {
    EqualTo = 'eq',
    NotEqualTo = 'neq',
    GreaterThan = 'gt',
    LessThan = 'lt',
    Like = 'like',
}

export const FilterSearchText: React.FC<IFilterSearchTextProps> = React.memo(({ rows, onFilterChange, alignment = 'left',defaultFilter }) => {
    const methods = useForm();
    const { register, handleSubmit, control, reset } = methods;
    const isMobile = IsSmallScreen();

    const handleReset = () => {
        reset(); // ✅ Correct way to reset form
        onFilterChange([]); // Clear filters
    };

    const onSubmit = (data: Record<string, any>) => {

        if(data.searchAll===undefined){
            handleReset()
        }
        if (!rows || !rows.fieldName) {
            console.warn("No field names found in rows.");
            return;
        }
    
        // ✅ Correct usage of `reduce()`
        // const appliedFilters: any[] = (rows.fieldName || []).reduce((acc: any[], field) => {
        //     if (data.searchAll!== "") { // Ensure valid input
        //         acc.push({
        //             field: rows.fieldName,
        //             operator: Operator.Like, // ✅ Use `Operator.EqualTo` if needed
        //             value: data.searchAll , // ✅ Uses actual field value
        //         });
        //     }
        //     return acc;
        // }, []);
        const appliedFilters: any[] =[]
        if(defaultFilter && defaultFilter.length>0){
            appliedFilters.push(...defaultFilter)
        }
        if(data.searchAll!==""){
        appliedFilters.push({
                        field: rows.fieldName,
                        operator: Operator.Like, // ✅ Use `Operator.EqualTo` if needed
                        value: data.searchAll , // ✅ Uses actual field value
                    });
                }
        // console.log("Applied Filters:", appliedFilters);
        onFilterChange(appliedFilters);
    };
    

    return (
        <FormProvider {...methods}>
            <form onSubmit={handleSubmit(onSubmit)}>
                <Divider sx={{ marginLeft: 1 }} />

                <Grid container spacing={2} sx={{ margin: 1 }}>
                    <Grid item sm={8}>
                        <WSTextField
                            control={control}
                            id="searchAll"
                            {...register('searchAll')}
                            name="searchAll"
                            label="Search"
                        />
                    </Grid>

                    {/* <Grid item xs={12}>
                        <Divider />
                    </Grid> */}
                        <Grid item sm={4}>
                            <Button sx={{ height: 32 }} type="submit" variant="contained" color="primary">
                                Search
                            </Button>
                        </Grid>
                        {/* <Grid item  sm={4}>
                            <Button sx={{ height: 32 }} type="button" onClick={handleReset} variant="contained" color="secondary">
                                Reset
                            </Button>
                        </Grid> */}
                    </Grid>
                
            </form>
        </FormProvider>
    );
});
